import React from 'react';
import { styled } from '@mui/material';

import { ListIcon, LocationIcon } from '@ocx/ui-icons';

import { ControlButton } from '../control-button.component';

const Container = styled('div', { shouldForwardProp: (propName) => propName !== 'offset' })<{ offset: boolean }>(
  ({ theme, offset }) => ({
    position: 'absolute',
    bottom: theme.spacing(2),
    transition: 'all 200ms',
    transitionDelay: '100ms',
    right: 0,
    ...(offset ? { bottom: `calc(var(--ion-safe-area-bottom) + ${theme.spacing(2)})` } : undefined),
  }),
);

type MapControlsProps = {
  offset: boolean;
  onLocationClick(): void;
  onListClick(): void;
  disabled: boolean;
};

export const MapControls: React.FC<MapControlsProps> = ({ offset, onLocationClick, onListClick, disabled }) => {
  return (
    <Container offset={offset}>
      <ControlButton
        icon={<LocationIcon sx={{ width: 20, height: 20 }} />}
        onClick={onLocationClick}
        disabled={disabled}
      />
      <ControlButton icon={<ListIcon />} onClick={onListClick} disabled={disabled} />
    </Container>
  );
};
